import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@up2stay/up2promo-ui';
import { MoreVertical, Smartphone, Trash2 } from 'lucide-react';

type TemplateDetailHeaderActionsProps = {
  moreOptionsLabel: string;
  previewLabel: string;
  deleteLabel: string;
  deleteAriaLabel: string;
  canEditTemplate: boolean;
  onPreview: () => void;
  onDelete: () => void;
};

export function TemplateDetailHeaderActions({
  moreOptionsLabel,
  previewLabel,
  deleteLabel,
  deleteAriaLabel,
  canEditTemplate,
  onPreview,
  onDelete,
}: TemplateDetailHeaderActionsProps) {
  return (
    <div className="flex items-center gap-2 shrink-0">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            size="icon"
            className="shrink-0 bg-transparent md:hidden"
          >
            <MoreVertical className="h-4 w-4" />
            <span className="sr-only">{moreOptionsLabel}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={onPreview}>
            <Smartphone className="mr-2 h-4 w-4" />
            {previewLabel}
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="text-destructive focus:text-destructive"
            disabled={!canEditTemplate}
            onClick={onDelete}
          >
            <Trash2 className="mr-2 h-4 w-4" />
            {deleteLabel}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <Button
        variant="outline"
        size="md"
        className="hidden gap-2 bg-transparent text-destructive hover:bg-destructive/10 hover:text-destructive md:inline-flex"
        disabled={!canEditTemplate}
        onClick={onDelete}
        aria-label={deleteAriaLabel}
      >
        {deleteAriaLabel}
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
